import React from 'react'
let i = 1;
let vector = [];
let vector_2 = [1];
let status = "";
let classStatus = "";
let totally = 0;
let shipping = 0;

for(i = 1; i<= cantProductsOrders;i++) {
    vector[i]=i;
}

let id_f = 0;
let order_id = 0;
let img = 0;
let name = 0;
let version = 0;
let price = 0;
let cant = 0;
let countTransport = 1;

const Info = function info ({orders,products,transports}){
    return (
        <main>
            <div className="back flex w90">
                <a href={https} className="flex">
                <img src={https+"img/back.svg"} alt="⬅"/>
                <span>Atrás</span>
                </a>
            </div>
            
            <section className="orders">
                <h2>Mis compras</h2>
                <div className="orderList colflex">
                    {orders.map((o)=>
                            {
                                
                                shipping = new Intl.NumberFormat().format(o.shipping);
                                shipping = shipping.replace(/,/g , ".");
                                totally = new Intl.NumberFormat().format(o.total);
                                totally = totally.replace(/,/g , ".");
                                return(
                                    <div className="itemOrder colflex">
                                        <div className="infoOrder colflex">
                                        <div className="part1 colflex">
                                            <p>ID de la compra: {o.reference}</p>
                                            <p>Fecha de la compra: {o.date}</p>
                                        </div>
                                        <div className="part2 colflex">
                                            <p>
                                                Envio: ${shipping}
                                            </p>
                                            <p>Total de la orden: ${totally}</p>
                                        </div>
                                        </div>
                                        <div className="resumeOrder colflex w90">
                                        <div className="items colflex">
                    {vector.map((v) => {
                        if (products.length == undefined) {
                            if(products[v] != undefined){
                                if(products[v].order_id != ''){
                                    order_id = products[v].order_id;
                                }else{
                                    order_id = ''
                                }
                                if(products[v].img != ''){
                                    img = products[v].img;
                                }else{
                                    img = ''
                                }
                                if(products[v].name != ''){
                                    name = products[v].name;
                                }else{
                                    name = ''
                                }
                                if(products[v].version != ''){
                                    version = products[v].version;
                                }else{
                                    version = ''
                                }
                                if(products[v].price != ''){
                                    price = products[v].price;
                                }else{
                                    price = ''
                                }
                                if(products[v].cant != ''){
                                    cant = products[v].cant;
                                }else{
                                    cant = ''
                                }
                                price = new Intl.NumberFormat().format(price);
                                price = price.replace(/,/g , ".");
                                if(order_id == o.id){
                                    return(
                                        <div className="product flex">
                                            <div className='image'>
                                                <div>
                                                    <img src={https+img} alt="product-image"/>
                                                </div>
                                            </div>
                                            <div className="colflex">
                                                <a>{name}</a>
                                                <span>{version}</span>
                                                <p>$ {price} x {cant}</p>
                                            </div>
                                        </div>   
                                    )
                                }
                                
                            }
                        }
                    }
                    )}
                                        </div>
                                        <div className="status colflex">            
                        {vector_2.map((v) => {
                            switch (o.status){
                                case 1:
                                    status = 'Confirmado'
                                    break;
                                case 2:
                                    status = 'Rechazado'
                                    break;
                                case 3:
                                    status = 'Pendiente'
                                    break;
                                case 4:
                                    status = 'Fallido'
                                    break;
                                case 4:
                                    status = 'Entregado'
                                    break;
                            }
                            if(status == "Confirmado"){
                                classStatus = ""
                            }else{
                                classStatus = "other"
                            }
                          }
                        )}
                                            <div className={"state flex "+classStatus}>
                                                <p>{status}</p>
                                            </div>
                                            {transports.map((t)=>
                                            {
                                                if(t.id == o.transport){
                                                    countTransport = 2;
                                                    return (
                                                    <div>
                                                        <p>Transportadora: {t.name}</p>
                                                        <p>Link de rastreo: <a href={t.link} target="_blank">Abrir</a></p>
                                                    </div>
                                                    )
                                                }
                                            }
                                            )}
                                            {vector_2.map((v) => {
                                                if(countTransport == 1){
                                                    return <p>Transportadora:</p>
                                                }
                                            }
                                            )}
                                            <span>N° de Guía: {o.guide_number}</span>
                                        </div>
                                        </div>
                                    </div>
                            )
                        }
                    )}
                </div>
            </section>
        </main>
    )
}

export default Info